<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <Detail
      :visible.sync="openEditDialogOptions.visible"
      :title="openEditDialogOptions.title"
      :mrpOtherStockInCode="openEditDialogOptions.mrpOtherStockInCode"
      :disabled="openEditDialogOptions.disabled"
      @reload="reload"
      @close="close"
    ></Detail>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import Detail from '../../detail'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, Detail },
  data() {
    return {
      usePage: true,
      openEditDialogOptions: {
        visible: false,
        mrpOtherStockInCode: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .mrpOtherStockInListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    close() {
      this.openEditDialogOptions.visible = false
      this.openEditDialogOptions.mrpOtherStockInCode = ''
    },
    openEditPage({ pageType, data = {} }) {
      const types = {
        add: this.$l('dialog_title_stockDetail_add') || '新增其他入库单信息',
        edit:
          this.$l('dialog_title_stockDetail_edit') || '编辑其他入库单信息',
        detail:
          this.$l('dialog_title_stockDetail_detail') || '查看其他入库单详情',
      }
      const { mrpOtherStockInCode = '' } = data
      if (mrpOtherStockInCode) {
        this.openEditDialogOptions.mrpOtherStockInCode = mrpOtherStockInCode
      }
      this.openEditDialogOptions.visible = true
      this.openEditDialogOptions.disabled = pageType == 'detail'
      this.openEditDialogOptions.title = types[pageType]
    },
  },
}
</script>
